const ButtonGroupConnected = (props) => {
  return <div className="button-group-connected">{props.children}</div>;
};
export default ButtonGroupConnected;
